var _circle, _circle2, _circle3, _path, _path2, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOtherPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 6.885,
    cy: 7.917,
    r: 0.836
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 35.863,
    cy: 7.876,
    r: 0.814
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 35.863,
    cy: 20.703,
    r: 0.814
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.915 22.366h17.229V6.258H5.47V18.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.605 21.049v15.416M3.897 28.757h15.416"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 21.307,
    cy: 14.312,
    r: 1.452,
    transform: "rotate(-55.999 21.307 14.312)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.292,
    cy: 14.312,
    r: 1.687
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled_only",
    cx: 29.569,
    cy: 14.312,
    r: 1.687
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOtherPayments);
export default __webpack_public_path__ + "static/media/addOtherPayments.1e379c9fed33262f26bd55d1bc81f0f2.svg";
export { ForwardRef as ReactComponent };